// Consumes a stored post-login destination (e.g. set by /verify when a logged-out member
// lands there from an email/banner). Returns true if it handled navigation so callers can bail.
export function consumeAfterLogin(navigate) {
  try {
    const dest = localStorage.getItem("os_after_login");
    if (dest) {
      localStorage.removeItem("os_after_login");
      navigate(dest, { replace: true });
      return true;
    }
  } catch (e) {}
  return false;
}
